<template>
  <div>
   
                 
                    <b-form-group>
                      <b-form-select
                        @change="onRowSelected"
                        :value="0"
                        size="md"
                        :options="optionsProvider"
                      >
                     
                      </b-form-select>
                    </b-form-group>
                 
    <!-- <b-input-group>
      <template v-slot:append>
        <b-input-group-text class="padding-all-none">
          <b-button
            @click="modalShow = !modalShow"
            class="bg-white btn-transparent border-none"
            ><font-awesome-icon class="color-orange" icon="search"
          /></b-button>
        </b-input-group-text>
      </template>
      <slot name="body"> </slot>
    </b-input-group> -->
    <div>
      <b-modal
        v-model="modalShow"
        hide-footer
        centered
        ok-only
        title="Proveedores"
        content-class="text-center"
      >
        <b-row>
          <b-col cols="12">
            <b-table
              :busy="isBusy"
              class="tab-b"
              ref="selectableTable"
              selectable
              :select-mode="selectMode"
              :items="optionsProvider"
              :fields="fields"
              @row-selected="onRowSelected"
              responsive="sm"
              :current-page="currentPageP"
              :per-page="0"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPageP"
              :total-rows="countTotalP"
              :per-page="perPage"
              pills
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "SearchProvider",
  data() {
    return {
      fields: [
        { key: "selected", label: "  " },
        { key: "user", label: "Usuario" },
        { key: "name", label: "Nombre" },
      ],
      optionsProvider: [],
      isBusy: false,
      selectMode: "single",
      selectedOptionProvider: [
        {
          description: "",
        },
      ],
      countTotalP: 0,
      currentPageP: 1,
      perPage: 10,
      modalShow: false,
    };
  },
  watch: {
    currentPageP: {
      handler: function () {
        this.getProvidersList().catch((error) => {
          console.error(error);
        });
      },
    },
  },
  computed:{
    ...mapState("module", ["username", "perfil", "idProvider","token"]),
  },
  created() {
    this.getCountProviders();
    this.getProvidersList();
  },
  methods: {
    async getCountProviders() {
      
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE + "/providers/count",
          {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );

        this.countTotalP = response.data.number;
      } catch (error) {
        this.countTotalP = 100;
      }
    },
    onRowSelected(items) {
      
      console.log(items)
      this.selectedOptionProvider = items;
      this.$emit("rowSelectedProvider", this.selectedOptionProvider);
      this.modalShow = false;
    },
    async getProvidersList() {
      try {
        this.isBusy = true;
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers?state=ACTIVE&pagination=false",
             {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              }
            }
        );
        //var sortedData= response.data.sort((a,b) => a.user.localeCompare(b.user))
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });
         // Ordenar alfabéticamente
          const sortedData = data.sort((a, b) => a.text.localeCompare(b.text));

        // Insertar la opción "Todos" al inicio
        sortedData.unshift({ value: 0, text: "Todos" });

        // Asignar a la propiedad de opciones
        this.optionsProvider = sortedData;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}
.form-control:disabled {
  background: white !important;
}
</style>